export const attendance = {
  en: {
    registerTitle: "Attendance register",
    suggestTitle: "{count} day(s) look like absences",
    suggestIntro: "Nobody clocked in on these working days, and nothing explains it — no leave, no holiday. Nothing has been recorded yet and none of it reaches payroll until you answer here.",
    suggestSelectAll: "Select every suggestion",
    suggestReason: "Reason (optional — a default is used if you leave it empty)",
    suggestConfirm: "Confirm {count} as absent",
    suggestDismiss: "Not an absence ({count})",
    suggestDefaultAbsent: "Confirmed absent from the register",
    suggestDefaultPresent: "Not an absence — confirmed present from the register",
    recordOvertime: "Record overtime",
    overtimeNote: "Recorded overtime waits for approval before it reaches payroll.",
    noPunches: "No punches were recorded for this day.",
    punchTime: "Time",
    punchType: "Punch",
    punchDistance: "Distance",
    punchReason: "Why it was refused",
    punchAccepted: "Accepted",
    punchRefused: "Refused",
    punchesFor: "Punches on {date}",
    correctionNote: "Correction reason: {reason}",
    clearCorrection: "Undo correction",
    clearCorrectionTitle: "Undo this correction?",
    clearCorrectionBody: "The day goes back to the status calculated from the punches.",
    reasonOutsideGeofence: "Outside the branch area",
    reasonNoLocation: "No location provided",
    reasonImprecise: "Location not precise enough",
    reasonDuplicate: "Duplicate punch",
    reasonNoCheckIn: "No open check-in",
    reasonBranchInactive: "Branch not accepting attendance",
    title: "Attendance",
    checkIn: "Check in",
    checkOut: "Check out",
    checkedInAt: "Checked in at {time}",
    checkedOutAt: "Checked out at {time}",
    notCheckedIn: "You have not checked in today.",
    statusPresent: "Present",
    statusLate: "Late",
    statusAbsent: "Absent",
    statusOnLeave: "On leave",
    statusHoliday: "Holiday",
    statusMissingCheckOut: "Missing check-out",
    lateBy: "Late by {minutes} min",
    workedHours: "Worked",
    correct: "Correct record",
    ownRecord: "Your own record",
    ownRecordHint: "Your own attendance is corrected by the system administrator.",
    correctionReason: "Why is this record being corrected?",
    lateMinutes: "Late (min)",
    overtimeMinutes: "Overtime (min)",
    hours: "Hours",
    totals: "Total",
    corrected: "Corrected",
    overtime: "Overtime",
    requestOvertime: "Record overtime",
    overtimeHours: "Overtime hours",
    locationRequired: "Location access is needed to record attendance.",
    locating: "Finding your location…",
    locatingAgain: "That reading was not precise enough — asking again…",
    earlyMinutes: "Early (min)",
    correctedIn: "Arrived at",
    correctedOut: "Left at",
    correctedTimesHint: "Leave a box empty to keep what is already recorded. A time typed here is what the lateness and the hours are then calculated from.",
    rangeToday: "Today",
    rangeYesterday: "Yesterday",
    rangeWeek: "Last 7 days",
    rangeMonth: "This month",
    refreshNow: "Refresh",
    correctedBy: "Corrected by {name} — {at}",
    correctedUnknown: "No author or reason was recorded for this correction.",
    refreshing: "Refreshing…",
    updatedAt: "Updated {time}",
    rosterTitle: "Who is in on {date}",
    rosterIn: "{count} in",
    rosterOut: "{count} not in",
    rosterNobody: "Nobody was expected on this day.",
    rosterNoRecord: "No record",
    rosterNoMeans: "{count} more are not listed: they have no way to clock in yet, so no day of theirs is counted either way.",
    notExpectedWeekend: "Weekend",
    notExpectedHoliday: "Holiday",
    notExpectedOnLeave: "On leave",
    notExpectedNotEmployed: "Not employed",
    notExpectedNotEligible: "No way to clock in yet",
    notExpectedBranchNotCounting: "Branch not counting yet",
    notExpectedNotFinished: "Day not over",
  },
  ar: {
    registerTitle: "سجل الحضور",
    suggestTitle: "{count} يوم يبدو غياباً",
    suggestIntro: "لم يسجل أحد حضوره في أيام العمل هذه، ولا يوجد ما يفسر ذلك — لا إجازة ولا عطلة. لم يُسجَّل شيء بعد، ولا يصل أي منها إلى الرواتب حتى تجيب هنا.",
    suggestSelectAll: "تحديد كل الاقتراحات",
    suggestReason: "السبب (اختياري — سيُستخدم نص افتراضي إذا تُرك فارغاً)",
    suggestConfirm: "تأكيد غياب {count}",
    suggestDismiss: "ليس غياباً ({count})",
    suggestDefaultAbsent: "تم تأكيد الغياب من السجل",
    suggestDefaultPresent: "ليس غياباً — تم تأكيد الحضور من السجل",
    recordOvertime: "تسجيل عمل إضافي",
    overtimeNote: "العمل الإضافي المسجّل ينتظر الاعتماد قبل أن يصل إلى مسير الرواتب.",
    noPunches: "لا توجد عمليات تسجيل لهذا اليوم.",
    punchTime: "الوقت",
    punchType: "العملية",
    punchDistance: "المسافة",
    punchReason: "سبب الرفض",
    punchAccepted: "مقبولة",
    punchRefused: "مرفوضة",
    punchesFor: "عمليات التسجيل في {date}",
    correctionNote: "سبب التعديل: {reason}",
    clearCorrection: "إلغاء التعديل",
    clearCorrectionTitle: "إلغاء هذا التعديل؟",
    clearCorrectionBody: "سيعود اليوم إلى الحالة المحتسبة من عمليات التسجيل.",
    reasonOutsideGeofence: "خارج نطاق الفرع",
    reasonNoLocation: "لم يتم تحديد الموقع",
    reasonImprecise: "الموقع غير دقيق بما يكفي",
    reasonDuplicate: "عملية مكررة",
    reasonNoCheckIn: "لا يوجد تسجيل حضور مفتوح",
    reasonBranchInactive: "الفرع لا يقبل تسجيل الحضور",
    title: "الحضور",
    checkIn: "تسجيل حضور",
    checkOut: "تسجيل انصراف",
    checkedInAt: "تم تسجيل الحضور الساعة {time}",
    checkedOutAt: "تم تسجيل الانصراف الساعة {time}",
    notCheckedIn: "لم تسجل حضورك اليوم.",
    statusPresent: "حاضر",
    statusLate: "متأخر",
    statusAbsent: "غائب",
    statusOnLeave: "في إجازة",
    statusHoliday: "عطلة",
    statusMissingCheckOut: "لم يسجل الانصراف",
    lateBy: "تأخر {minutes} دقيقة",
    workedHours: "ساعات العمل",
    correct: "تعديل السجل",
    ownRecord: "سجلك أنت",
    ownRecordHint: "تعديل حضورك يتم من مدير النظام.",
    correctionReason: "ما سبب تعديل هذا السجل؟",
    lateMinutes: "التأخير (دقيقة)",
    overtimeMinutes: "العمل الإضافي (دقيقة)",
    hours: "الساعات",
    totals: "الإجمالي",
    corrected: "معدّل",
    overtime: "العمل الإضافي",
    requestOvertime: "تسجيل عمل إضافي",
    overtimeHours: "ساعات العمل الإضافي",
    locationRequired: "يجب السماح بالوصول للموقع لتسجيل الحضور.",
    locating: "جارٍ تحديد موقعك…",
    locatingAgain: "القراءة لم تكن دقيقة بما يكفي، نحاول مرة أخرى…",
    earlyMinutes: "حضور مبكر (دقيقة)",
    correctedIn: "وصل الساعة",
    correctedOut: "انصرف الساعة",
    correctedTimesHint: "اترك الخانة فارغة للإبقاء على المسجَّل. الوقت الذي تكتبه هنا هو ما يُحتسب منه التأخير وساعات العمل.",
    rangeToday: "اليوم",
    rangeYesterday: "أمس",
    rangeWeek: "آخر 7 أيام",
    rangeMonth: "هذا الشهر",
    refreshNow: "تحديث",
    correctedBy: "عدّلها {name} — {at}",
    correctedUnknown: "ما سُجّل لهذا التعديل فاعل ولا سبب.",
    refreshing: "يُحدَّث…",
    updatedAt: "آخر تحديث {time}",
    rosterTitle: "من حضر في {date}",
    rosterIn: "{count} حاضر",
    rosterOut: "{count} لم يحضر",
    rosterNobody: "لا أحد مطلوب حضوره في هذا اليوم.",
    rosterNoRecord: "لا يوجد تسجيل",
    rosterNoMeans: "و{count} غير مدرجين: ما عندهم وسيلة تسجيل بعد، فلا يُحسب لهم حضور ولا غياب.",
    notExpectedWeekend: "عطلة أسبوعية",
    notExpectedHoliday: "عطلة رسمية",
    notExpectedOnLeave: "في إجازة",
    notExpectedNotEmployed: "ليس على رأس العمل",
    notExpectedNotEligible: "ما عنده وسيلة تسجيل بعد",
    notExpectedBranchNotCounting: "الفرع لم يبدأ العد",
    notExpectedNotFinished: "اليوم لم ينتهِ",
  },
} as const;
